import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Upload, message, Button } from 'antd'
// 刪除檔案 路徑
//import { delFile_BulletinBoard } from '../../api/'

import { DEFAULT_IMAGE_URL } from '../../utils/contrains'
import storageUtils from '../../utils/storageUtils'

export default class FlexibleLogGroupExcelProcess extends Component {

    // 基礎通用參數 //////////////////////////////////////////////  

    state = {
        previewVisible: false,
        previewImage: '',
        fileList: []
    }

    // 來自上層組件的參數
    static propTypes = {
        data_source: PropTypes.array,
        api_url: PropTypes.string.isRequired,
        data_info: PropTypes.object,
        creator: PropTypes.object,
        groupid: PropTypes.string
    }

    UNSAFE_componentWillMount() {
        const { data_source } = this.props
        const fileList = this.init_edit_items(data_source)
        this.setState({ fileList })
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    init_edit_items = (files) => {
        // console.log('files', files)
        if (files) {
            return files.reduce((row_pre, row) => {
                row_pre.push({
                    uid: row.Uid,
                    name: row.FileNewName,
                    status: 'done',
                    url: row.FileUrl
                })
                return row_pre
            }, [])
        } else {
            return []
        }
    }

    // 操作互動處理 //////////////////////////////////////////////

    handleCancel = () => this.setState({ previewVisible: false })

    handlePreview = file => {
        this.setState({
            previewVisible: true,
            previewImage: file.url || file.thumUrl,
        })
    }

    /* file:為當前被操作的文件 */
    handleUpload = ({ fileList }) => {
        //  console.log('fileList', fileList);

        this.setState({ fileList }, () => {
            const { api_url } = this.props
            const url = DEFAULT_IMAGE_URL + api_url
            const { fileList } = this.state
            const { token } = storageUtils.getUser()
            const formData = new FormData();

            fileList.forEach((file) => {
                formData.append('file', file.originFileObj);
                formData.append("table", 'group_date_staff');
                formData.append("remarks", '日期彈班區間人員清單');
                formData.append("author", this.props.creator.userCode);
                formData.append("token", token);
                formData.append("num", this.props.groupid);
            });

            fetch(url, {
                method: 'POST',
                withCredentials: false,
                headers: { Authorization: 'Bearer ' + token },
                body: formData
            })
                .catch(error => console.error('Error:', error))
                .then((response) => response.json())
                .then((responseJson) => {
                    message.info(responseJson.message)
                })
        });
    };


    // 外部接收方法 ////////////////////////////////////   

    // 提供給父組件(product-modify)使用
    output_files = () => { return this.state.fileList.map(file => file.url) }

    /////////////////////////////////////////////////////////////

    render() {
        const { fileList } = this.state
        const uploadButton = (
            <div>
                <Button type="primary" >
                    <i className="fas fa-file-upload"></i><span style={{ marginLeft: '4px' }}>上傳</span>
                </Button>
            </div>
        )
        return (
            <div>
                <Upload
                    listType="text"
                    accept="application/vnd.ms-excel"
                    maxCount={1}
                    fileList={fileList}
                    onPreview={this.handlePreview}
                    onChange={this.handleUpload}
                    beforeUpload={() => false} 
                >
                    {fileList.length >= 1 ? null : uploadButton}
                </Upload>

            </div>
        )
    }

}